import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';

const TOAST_DURATION_MS = 2600;

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ToastComponent {
  readonly message = input<string | null>(null);
  readonly dismissed = output<void>();

  protected readonly shown = signal<string | null>(null);
  private timer: ReturnType<typeof setTimeout> | undefined;

  constructor() {
    effect(() => {
      const text = this.message();
      clearTimeout(this.timer);
      this.shown.set(text);
      if (!text) return;
      this.timer = setTimeout(() => {
        this.shown.set(null);
        this.dismissed.emit();
      }, TOAST_DURATION_MS);
    });
    inject(DestroyRef).onDestroy(() => clearTimeout(this.timer));
  }
}
